import { TimelineLite, Power0, Power2, Back } from 'gsap';

const animation = (audioFn, nonTCAPage) => {
    const tl = new TimelineLite();

    tl.eventCallback('onStart', audioFn)
        .set(['.replay-section'], {pointerEvents: 'none'})
        .from('.insurance-benefits__heading', .8, {alpha: 0, ease: Power0.easeNone })
        .staggerFrom('.insurance-benefits__column', 1, {alpha: 0.8, rotationY: 180, ease: Back.easeOut.config(1), delay: .5}, 0.5);
    if (nonTCAPage) {
        tl.from('#calendar', .8, {alpha: .5, y: '+=115%'}, '+=0.4')
        .from('#money', .7, { scale: 0, transformOrigin:"50% 50%", ease: Power2.easeIn},  '+=.4');
    }
    tl.from('#person', .8, {alpha: .5, y: '+=115%'}, '+=0.4')
        .from('#circle-with-hearth', .7, { scale: 0, transformOrigin:"50% 50%", ease: Power2.easeIn},  '+=.4')
        .set('.replay-section', {pointerEvents: 'auto'}, '+=.3')
        .from('.replay-section', 1, {alpha: 0, delay: 0.5, ease: Power0.easeNone})
} 

export default animation